import { LINKS, RouterPaths } from "../../app/appConstants";
import { Route, Switch } from "react-router";
import React, { useCallback, useEffect } from "react";
import Partner from "./Partner.jsx";
import PartnerCampaigns from "./PartnerCampaigns/PartnerCampaigns.jsx";
import PartnerMenu from "./PartnerMenu.jsx";
import { PartnerAccessStyled, PartnerContent, PartnerWrapper } from "./styled/PartnerStyled.js";
import { MainHeader } from "../../components/main-header/MainHeader.jsx";
import { Alert, Button, FormGroup } from "react-bootstrap";
import ProfileButton from "../Account/components/ProfileButton/ProfileButton.jsx";
import { Link } from "react-router-dom";
import { useSetBodyBackgroundColor } from "../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks.js";
import PartnerPayment from "./PartnerPayment/PartnerPayment.jsx";
import { createStructuredSelector } from "reselect";
import { getPartnerParams } from "./partnerSelectors.js";
import { connect } from "react-redux";
import { BinIcon } from "../../components/icon/Icon.jsx";
import PartnerStatistics from "./PartnerStatistics/PartnerStatistics";
import { LoginBoxStyled, LoginStyled } from "../Login/components/styled/LoginStyled.js";
import { acceptPartnerRulesAction, loadPartnerPostbacksAction } from "./partnerActions.js";
import PartnerSupport from "./PartnerSupport.jsx";
import PartnerApiDocs from "./PartnerApiDocs/PartnerApiDocs";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

function PartnerRoute(props) {
    const {getLangPath} = useLangContext();
    useSetBodyBackgroundColor('var(--app-bg-modal-color)', true);
    const {
        acceptPartnerRulesAction,
        loadPartnerPostbacksAction,
        partnerParams
    } = props;

    useEffect(() => {
        loadPartnerPostbacksAction();
    }, [loadPartnerPostbacksAction])

    const submitRulesHandler = useCallback(() => {
        acceptPartnerRulesAction();
    }, [acceptPartnerRulesAction]);

    return <div>
        <MainHeader>
            <Button variant="outline-primary" size="sm" as={Link} to={RouterPaths.trade}>
                {getLangPath('verify.trade')}
            </Button>
            <ProfileButton className="ms-2 ms-sm-3"/>
        </MainHeader>
        <PartnerWrapper>
            {!partnerParams.rules_accepted && <>
                <LoginStyled>
                    <LoginBoxStyled className="d-flex flex-column align-items-center"
                                    style={{background: 'var(--app-bg-color)'}}>
                        <PartnerAccessStyled>
                            <BinIcon name={'IcReferrals'} style={{fontSize: '48px'}}/>
                            <h1 className="mb-4 text-center">Affiliate program</h1>
                            <p className="text-center">Please read and accept <Link to={LINKS.affiliateAgreementDoc}
                                                                                    target={'__blank'}>Affiliate
                                Agreement</Link> and <Link to={LINKS.communicationsPolicyFxDoc}
                                                           target={'__blank'}>Communications Policy</Link> and <Link
                                    to={LINKS.privacyPolicyDoc}
                                    target={'__blank'}>Privacy Policy</Link> to continue</p>
                        </PartnerAccessStyled>
                        <FormGroup>
                            <Button variant={'primary'} onClick={submitRulesHandler}>Accept all & continue</Button>
                        </FormGroup>
                    </LoginBoxStyled>
                </LoginStyled>
            </>}
            {partnerParams.rules_accepted && <>
                <PartnerMenu/>
                <PartnerContent>
                    {
                            !partnerParams.payment_info && <Alert variant={'warning'} className="mb-3">
                                <BinIcon name={'IcExclamationMarkTriangle'}/>
                                <span>{getLangPath('partner.payment.warning')}</span>
                            </Alert>
                    }
                    <Switch>
                        <Route exact path={RouterPaths.partnerApiDocs} component={PartnerApiDocs}/>
                        <Route exact path={RouterPaths.partnerCampaigns} component={PartnerCampaigns}/>
                        <Route exact path={RouterPaths.partnerPayment} component={PartnerPayment}/>
                        <Route exact path={RouterPaths.partnerStats} component={PartnerStatistics}/>
                        <Route exact path={RouterPaths.partnerSupport} component={PartnerSupport}/>
                        <Route path={RouterPaths.partner} component={Partner}/>
                    </Switch>
                </PartnerContent>
            </>}
        </PartnerWrapper>
    </div>
}

const mapStateToProps = createStructuredSelector({
    partnerParams: getPartnerParams,
});

const mapDispatchToProps = {
    acceptPartnerRulesAction,
    loadPartnerPostbacksAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerRoute);
